import { takeLatest } from 'redux-saga/effects';
import {
    FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_REQUEST,
} from '../../redux/modules/previousPurchaseInvoiceLines/previousPurchaseInvoiceLines-actions';
import previousPurchaseInvoiceLinesWorker from './previousPurchaseInvoiceLinesWorker';

export default function* previousPurchaseInvoiceLinesWatcher() {
    yield takeLatest(FETCH_PREVIOUS_PURCHASE_INVOICE_LINES_REQUEST, previousPurchaseInvoiceLinesWorker);
}
